import { PatientInsurance, PatientInsuranceType } from '../model/patient-insurance'

/**
 * Ensure that the patient insurances are sorted in the order of PRIMARY, SECONDARY, TERTIARY
 */
export const sortPatientInsurance = (insurances: PatientInsurance[]): PatientInsurance[] => {
  const order = [PatientInsuranceType.PRIMARY, PatientInsuranceType.SECONDARY, PatientInsuranceType.TERTIARY]

  return order.map((type) => insurances.find((item) => item.type === type)).filter(Boolean)
}
